'use client';

import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';
import { useTranslations } from 'next-intl';

/**
 * Explains why the panel offers "Notify me" instead of "Add to cart". It sits
 * above the quantity row so the notice spans the full panel width.
 */
export function UnavailableNotice() {
  const t = useTranslations('ProductChooser');

  return (
    <output className="flex items-center gap-3 text-[#EC041B]">
      <ExclamationTriangleIcon className="h-6 w-6 shrink-0" aria-hidden="true" />
      <span className="text-base font-bold">
        {t('This product variant is currently not available')}
      </span>
    </output>
  );
}
